import React from 'react';
import Helmet from "react-helmet";

export default ({children}) => (
    <div className="rounded shadow my-4">
        <a className="twitter-timeline" data-lang="it" data-height="400" href="https://twitter.com/DPCgov?ref_src=twsrc%5Etfw">
            Tweets by DPCgov
        </a>
        <Helmet>
            <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8"/>
        </Helmet>
    </div>
);
